var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAmberOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WarningAmberOutlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 13.5207C10.6223 13.5207 10.3107 13.209 10.3107 12.8332V8.24986C10.3107 7.87403 10.6223 7.56236 10.9982 7.56236C11.374 7.56236 11.6857 7.87403 11.6857 8.24986V12.8332C11.6857 13.209 11.374 13.5207 10.9982 13.5207Z",
    fill: "#ED6C02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 16.4999C10.9432 16.4999 10.879 16.4907 10.8148 16.4815C10.7598 16.4724 10.7048 16.454 10.6498 16.4265C10.5948 16.4082 10.5398 16.3807 10.4848 16.344L10.3473 16.234C10.1823 16.0599 10.0815 15.8215 10.0815 15.5832C10.0815 15.3449 10.1823 15.1065 10.3473 14.9324L10.4848 14.8224C10.5398 14.7857 10.5948 14.7582 10.6498 14.7399C10.7048 14.7124 10.7598 14.694 10.8148 14.6849C10.934 14.6574 11.0623 14.6574 11.1723 14.6849C11.2365 14.694 11.2915 14.7124 11.3465 14.7399C11.4015 14.7582 11.4565 14.7857 11.5115 14.8224L11.649 14.9324C11.814 15.1065 11.9148 15.3449 11.9148 15.5832C11.9148 15.8215 11.814 16.0599 11.649 16.234L11.5115 16.344C11.4565 16.3807 11.4015 16.4082 11.3465 16.4265C11.2915 16.454 11.2365 16.4724 11.1723 16.4815C11.1173 16.4907 11.0532 16.4999 10.9982 16.4999Z",
    fill: "#ED6C02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44315 20.3132H16.5531C18.3406 20.3132 19.7065 19.6624 20.4031 18.4982C21.0998 17.3157 20.999 15.8124 20.1281 14.2449L14.5731 4.24402C13.6565 2.59402 12.3915 1.68652 10.9981 1.68652C9.60481 1.68652 8.33981 2.59402 7.42315 4.24402L1.86815 14.2357C0.997313 15.8032 0.905647 17.3157 1.59315 18.489C2.28981 19.6624 3.65565 20.3132 5.44315 20.3132ZM8.62398 4.91319C9.29315 3.72152 10.1365 3.06152 10.9981 3.06152C11.8598 3.06152 12.7031 3.72152 13.3723 4.91319L18.9365 14.914C19.5598 16.0415 19.6698 17.059 19.2298 17.8015C18.7898 18.544 17.8456 18.9474 16.5623 18.9474H5.45231C4.16898 18.9474 3.21565 18.544 2.78481 17.8015C2.35398 17.059 2.45481 16.0324 3.07815 14.914L8.62398 4.91319Z",
    fill: "#ED6C02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmberOutlined);
export default __webpack_public_path__ + "static/media/WarningAmberOutlined.027e5ad3d67a651df2cc05292e50f831.svg";
export { ForwardRef as ReactComponent };